// ©2024 Austin App House. All rights reserved.
import React from 'react';
// eslint-disable-next-line import/no-cycle
import Content from '../../components/manageCustomFields/Content';

const ManageCustomFields = ({ mainContainer }) => (
  <>
    <Content />
  </>
);

export default ManageCustomFields;
